import React from 'react';

const CustomHeader = ({ value }: { value: string }) => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '30px', // or 100vh for full screen
            color: '#25d366',
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'center',
            marginTop:"20px"
        }}>
            {value}
        </div>
    );
};

export default CustomHeader;
